module.exports = __webpack_public_path__ + "static/media/nav_circle_after.523fac06.svg";